import { useState, useCallback } from "react";
const isBrowser = typeof window !== "undefined";
const getItem = (key) => {
  const valueFromSessionStorage = sessionStorage.getItem(key);
  if (valueFromSessionStorage) {
    try {
      const credentials = JSON.parse(valueFromSessionStorage);
      if (credentials.token)
        return valueFromSessionStorage;
    } catch (e) {
    }
  }
  return localStorage.getItem(key);
};
const setItem = (key, value, storageType) => {
  const isInvalid = !value || value === "null";
  const storage = storageType === "local" ? localStorage : sessionStorage;
  if (isInvalid)
    return storage.removeItem(key);
  return storage.setItem(key, value);
};
const nextValue = (value) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return false;
  }
};
const useStickyState = (defaultValue, key) => {
  const [value, setValue] = useState(() => {
    const stickyValue = isBrowser ? getItem(key) : null;
    return nextValue(stickyValue) || stickyValue || defaultValue;
  });
  const handleSetValue = useCallback(
    (value2, storageType) => {
      setValue((pv) => {
        const isObjectEntry = typeof pv === "object" && typeof value2 === "object";
        setItem(key, isObjectEntry && value2 ? JSON.stringify({ ...pv, ...value2 }) : JSON.stringify(value2), storageType);
        return isObjectEntry && value2 ? { ...pv, ...value2 } : value2;
      });
    },
    [setItem, key]
  );
  return [value, handleSetValue];
};
export {
  getItem,
  useStickyState
};
